const { PET_SIZES, PET_TEMPERAMENTS, PET_TYPES } = require('../constants')

const getSizeLabel = (size, type) => {
  switch (size) {
    case PET_SIZES.MINI:
      return 'Mini'
    case PET_SIZES.LITTLE:
      if (type === PET_TYPES.CAT) {
        return 'Pêlo curto'
      }
      return 'Pequeno'
    case PET_SIZES.MID:
      return 'Médio'
    case PET_SIZES.BIG:
      if (type === PET_TYPES.CAT) {
        return 'Pêlo longo'
      }
      return 'Grande'
    case PET_SIZES.HUGE:
      return 'Gigante'
    default:
      throw new Error(`Tamanho de pet não mapeado "${size}"`)
  }
}

const getTemperamentLabel = (temperament) => {
  switch (temperament) {
    case PET_TEMPERAMENTS.TAME:
      return 'Manso'
    case PET_TEMPERAMENTS.AGGRESSIVE:
      return 'Bravo'
    default:
      throw new Error(`Tipo de temperamento não mapeado "${temperament}"`)
  }
}

const getTypeLabel = (type) => {
  switch (type) {
    case PET_TYPES.DOG:
      return 'Cachorro'
    case PET_TYPES.CAT:
      return 'Gato'
    case PET_TYPES.RABBIT:
      return 'Coelho'
    case PET_TYPES.PIGGY_INDIAN:
      return 'Porquinho da Índia'
    case PET_TYPES.FERRET:
      return 'Furão'
    default:
      throw new Error(`Tipo de pet não mapeado "${type}"`)
  }
}

module.exports = {
  getSizeLabel,
  getTemperamentLabel,
  getTypeLabel
}
